import React from 'react'
import EmployeeTable from './staff/EmployeeTable'

export default function Employees() {
  return (
    <div style={{padding:15}}>
        <EmployeeTable />
    </div>
  )
}
